<div class="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 px-4 backdrop-blur-sm">
  <div class="w-full max-w-[550px] rounded-2xl bg-white p-8 shadow-2xl">
    <div class="mb-6 flex items-center justify-between border-b pb-4">
      <h4 class="text-[20px] font-bold text-gray-800" i18n="@@attr.import.title">Import Global Attribute</h4>
      <button
        type="button"
        (click)="onClose.emit()"
        class="cursor-pointer text-xl font-bold text-gray-400 hover:text-red-500">
        ×
      </button>
    </div>

    <div class="flex flex-col gap-6">
      <div class="flex flex-col gap-2">
        <label class="text-sm font-bold text-gray-700" i18n="@@attr.import.selectLabel">Select Global Attribute</label>

        <div class="relative">
          <select
            class="focus-border-primary w-full cursor-pointer appearance-none rounded-xl border border-gray-200 bg-white p-3 pe-10 text-sm outline-none"
            [class.text-gray-900]="selectedAttr()"
            [class.text-placeholder]="!selectedAttr()"
            (change)="handleSelect($event)">
            <option value="" selected disabled i18n="@@attr.import.selectPlaceholder" class="text-gray-900">
              Choose from defaults...
            </option>
            @for (gAttr of globalAttributes(); track gAttr.attributeKey.id) {
              <option [value]="gAttr.attributeKey.id" class="text-gray-900">{{ getTitle(gAttr.attributeKey) }}</option>
            }
          </select>
          <span class="pointer-events-none absolute inset-y-0 end-3 flex items-center text-gray-400">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </span>
        </div>

        @if (duplicateError()) {
          <span class="text-xs font-medium text-red-500" i18n="@@attr.validation.titleAlreadyExists">
            This attribute already exists
          </span>
        }
      </div>

      @if (selectedAttr()) {
        <div class="flex flex-col gap-2">
          <label class="text-xs font-bold text-gray-400 uppercase" i18n="@@attr.import.includedValues">
            Included Values
          </label>
          <div class="flex flex-wrap gap-2 rounded-xl border border-gray-100 bg-gray-50/50 p-4">
            @for (val of selectedAttr()?.attributeValues; track $index) {
              <span class="rounded-lg border border-gray-200 bg-white px-3 py-1 text-xs font-bold text-gray-500">
                {{ getTitle(val) }}
              </span>
            }
          </div>
        </div>
      }
    </div>

    <div class="mt-8 flex gap-4">
      <button
        type="button"
        (click)="onClose.emit()"
        class="flex-1 cursor-pointer rounded-xl border border-gray-200 py-3 font-bold text-gray-500 transition-all hover:bg-gray-50"
        i18n="@@product.button.cancel">
        Cancel
      </button>
      <button
        type="button"
        (click)="handleConfirm()"
        [disabled]="!selectedAttr() || duplicateError()"
        class="bgPrimaryColor flex-1 cursor-pointer rounded-xl py-3 font-bold text-white shadow-md transition-all disabled:opacity-50"
        i18n="@@attr.button.confirmImport">
        Confirm Import
      </button>
    </div>
  </div>
</div>
